namespace RioERP.Orders {
    export interface FranchiseeOrdersForm {
        OrderDate: Serenity.DateEditor;
        OrderNumber: Serenity.StringEditor;
        SourceOrderNumber: Serenity.StringEditor;
        ESourceType: Serenity.EnumEditor;
        SourceName: Serenity.StringEditor;
        MarkAsPaid: Serenity.BooleanEditor;
        FranchiseeId: Serenity.LookupEditor;
        CustomerName1: Serenity.StringEditor;
        CustomerEmail1: Serenity.EmailEditor;
        CustomerEmail2: Serenity.StringEditor;
        CustomerMobile11: Serenity.StringEditor;
        CustomerMobile21: Serenity.StringEditor;
        InvoiceCompanyId: Serenity.LookupEditor;
        ExamAttemptYear: Serenity.StringEditor;
        BillingAddress1: Serenity.StringEditor;
        BillingAddress2: Serenity.StringEditor;
        BillingCity: Serenity.StringEditor;
        BillingStateId: Serenity.LookupEditor;
        BillingPincode: Serenity.IntegerEditor;
        ShippingToName: Serenity.StringEditor;
        ShippingAddress1: Serenity.StringEditor;
        ShippingAddress2: Serenity.StringEditor;
        ShippingCity: Serenity.StringEditor;
        ShippingStateId: Serenity.LookupEditor;
        ShippingPincode: Serenity.IntegerEditor;
        OrderProducts: FranchiseeOrderProductsEditor;
        GrossAmount: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxableAmount: Serenity.DecimalEditor;
        EPaymentType: Serenity.EnumEditor;
        EInvoiceTo: Serenity.EnumEditor;
        GenerateSerialKey: Serenity.BooleanEditor;
    }

    export class FranchiseeOrdersForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.FranchiseeOrders';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FranchiseeOrdersForm.init)  {
                FranchiseeOrdersForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.EnumEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.LookupEditor;
                var w5 = s.EmailEditor;
                var w6 = s.IntegerEditor;
                var w7 = FranchiseeOrderProductsEditor;
                var w8 = s.DecimalEditor;

                Q.initFormType(FranchiseeOrdersForm, [
                    'OrderDate', w0,
                    'OrderNumber', w1,
                    'SourceOrderNumber', w1,
                    'ESourceType', w2,
                    'SourceName', w1,
                    'MarkAsPaid', w3,
                    'FranchiseeId', w4,
                    'CustomerName1', w1,
                    'CustomerEmail1', w5,
                    'CustomerEmail2', w1,
                    'CustomerMobile11', w1,
                    'CustomerMobile21', w1,
                    'InvoiceCompanyId', w4,
                    'ExamAttemptYear', w1,
                    'BillingAddress1', w1,
                    'BillingAddress2', w1,
                    'BillingCity', w1,
                    'BillingStateId', w4,
                    'BillingPincode', w6,
                    'ShippingToName', w1,
                    'ShippingAddress1', w1,
                    'ShippingAddress2', w1,
                    'ShippingCity', w1,
                    'ShippingStateId', w4,
                    'ShippingPincode', w6,
                    'OrderProducts', w7,
                    'GrossAmount', w8,
                    'NetAmount', w8,
                    'TaxableAmount', w8,
                    'EPaymentType', w2,
                    'EInvoiceTo', w2,
                    'GenerateSerialKey', w3
                ]);
            }
        }
    }
}
